import { css } from '@linaria/atomic';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

export const pageStyle = css`
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  min-height: 100%;
  container-type: inline-size;
  opacity: 0;
  animation: fadeIn ease 0.15s;
  animation-fill-mode: forwards;
  display: grid;
  grid-template-areas: 'header' 'content';
  grid-template-rows: auto 1fr;
  grid-template-columns: 100%;
  background-color: ${theme.colors.white};
  width: 100%;
  font-size: ${theme.font.size.medium};
  padding: ${theme.spacing(4)};
  max-width: var(--page-max-width);

  @media (max-width: ${breakpoints.small.max}px) {
    padding: ${theme.spacing(3)};
  }
`;

export const pageSettingsStyle = css`
  background-color: ${theme.colors.neutral5};
`;

export const pageHeader = css`
  margin-bottom: ${theme.spacing(4)};
  grid-area: header;
  &:empty {
    display: none;
  }
`;

export const pageContent = css`
  grid-area: content;
`;

export const loadingContainerStyle = css`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const breadcrumbsSpacingStyle = css`
  margin-bottom: ${theme.spacing(1)};
`;

export const headerContentStyle = css`
  display: grid;
  grid-template-areas: 'title title actions' 'subtitle subtitle subtitle';
  grid-template-columns: repeat(auto-fit, minmax(0, auto));
  grid-template-rows: auto auto;
  align-items: center;
  gap: ${theme.spacing(1)};

  @container (max-width: ${breakpoints.small.max}px) {
    grid-template-areas: 'title title' 'subtitle subtitle' 'actions actions';
    grid-template-rows: auto auto auto;
  }

  @container (max-width: ${breakpoints.xsmall.max}px) {
    grid-template-areas: 'title' 'subtitle' 'actions';
    grid-template-rows: auto auto auto;
  }
`;

export const headerTitleStyle = css`
  grid-area: title;
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};

  @container (max-width: ${breakpoints.small.max}px) {
    min-width: 0;
    flex-direction: column;
    align-items: start;
    gap: 0;
  }
`;

export const subtitleTextStyle = css`
  grid-area: subtitle;
  margin: 0;
`;

export const subtitleContainerStyle = css`
  grid-area: subtitle;
  margin: 0;
`;

export const expandTextStyle = css`
  max-width: 700px;
`;

export const headerActionStyle = css`
  grid-area: actions;
  width: fit-content;
  justify-self: end;

  @container (max-width: ${breakpoints.small.max}px) {
    justify-self: start;
  }
`;

export const settingsChipContainerStyle = css`
  display: flex;
  gap: ${theme.spacing(1)};
  align-items: center;
`;

export const settingsChipActionStyle = css`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

export const skeletonLoaderStyle = css`
  background-color: ${theme.colors.neutral10};
`;
